module.exports = "/assets/fe78317635f26d4eea36449fcc7fb816.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IG.png
// module id = 1473
// module chunks = 0